import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="flex h-screen items-center justify-center text-muted-foreground">Loading...</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) {
    const dest =
      user.role === "owner" ? "/owner" :
      user.role === "parent" ? "/parent" :
      user.role === "student" ? "/student" :
      (user.role === "cleaner" || user.role === "service_provider") ? "/cleaner" :
      "/admin";
    return <Navigate to={dest} replace />;
  }
  return children;
}
